import React from "react";
import {
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  Area,
  ComposedChart,
} from "recharts";

const TestRunComparisonChart = ({ data }) => {
  if (!data || !data.progressData || data.progressData.length === 0) {
    return null;
  }

  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      return (
        <div className="bg-white p-4 border border-gray-300 rounded shadow-md">
          <p className="font-bold">{`Time Point: ${label + 1}`}</p>
          {payload.map((entry, index) => (
            <p key={index} style={{ color: entry.color }}>
              {entry.name}: {(entry.value * 100).toFixed(1)}%
            </p>
          ))}
        </div>
      );
    }
    return null;
  };

  const chartData = data.progressData.map((item, index) => ({
    timePoint: index + 1,
    current: item.current,
    previous: item.previous,
  }));

  return (
    <div className="flex flex-col items-center w-full p-4 bg-gray-50 rounded-lg shadow mb-4">
      <h2 className="text-xl font-bold mb-4">Test Progress Comparison</h2>

      <div className="w-full h-64">
        <ResponsiveContainer width="100%" height="100%">
          <ComposedChart data={chartData}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis
              dataKey="timePoint"
              label={{ value: "Time Points", position: "insideBottom", offset: -5 }}
            />
            <YAxis
              label={{
                value: "Progress (%)",
                angle: -90,
                position: "insideLeft",
              }}
              tickFormatter={(value) => `${(value * 100).toFixed(0)}%`}
            />
            <Tooltip content={<CustomTooltip />} />
            <Legend />

            <Area
              type="monotone"
              dataKey="previous"
              stroke="#8884d8"
              fill="#8884d8"
              fillOpacity={0.1}
              name="Previous Run"
            />

            <Line
              type="monotone"
              dataKey="current"
              stroke="#82ca9d"
              strokeWidth={2}
              dot={{ fill: "#82ca9d" }}
              name="Current Run"
            />
          </ComposedChart>
        </ResponsiveContainer>
      </div>

      <div className="mt-4 w-full">
        <h3 className="font-bold mb-2">Summary</h3>
        <div className="grid grid-cols-2 gap-4">
          <div className="bg-blue-100 p-3 rounded">
            <p className="font-bold">Current Progress</p>
            <p className="text-lg">
              {(data.progressData[data.progressData.length - 1].current * 100).toFixed(1)}%
            </p>
          </div>
          <div className="bg-purple-100 p-3 rounded">
            <p className="font-bold">Previous Progress</p>
            <p className="text-lg">
              {(data.progressData[data.progressData.length - 1].previous * 100).toFixed(1)}%
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TestRunComparisonChart;
